(function() {
  const shipsTo = ["AU","AT","BE","BR","CA","FR","DE","GR","IE","IT","LB","MX","NL","NO","PT","SA","ES","SE","CH","AE","GB","US"];

  function getCountryFromCookie() {
    const match = document.cookie.match(/localization=([A-Z]{2})/);
    return match ? match[1] : null;
  }

  function updateBuyButton() {
    const country = getCountryFromCookie();
    if (!country) return;

    if (!shipsTo.includes(country)) {
      // Fix product page buy button
      const btn = document.querySelector('.product-form__submit');
      if (btn) {
        btn.disabled = true;
        const span = btn.querySelector('span');
        if (span) span.textContent = 'Not shipping to your location yet';
      }

      // Fix "Sold Out" buttons on collection/home page
      document.querySelectorAll('a.button.outline.button--full-width').forEach(function(badge) {
        if (badge.textContent.trim() === 'Sold out') {
          badge.textContent = 'Not shipping to your location yet';
        }
      });

      // Hide "Sold Out" badge in top-left corner of cards
      document.querySelectorAll('span.badge.bg-contrast').forEach(function(badge) {
        if (badge.textContent.trim() === 'Sold out') {
          badge.style.display = 'none';
        }
      });
    }
  }

  updateBuyButton();
  setTimeout(updateBuyButton, 500);
  setTimeout(updateBuyButton, 1500);

  document.addEventListener('click', function() {
    setTimeout(updateBuyButton, 500);
  });
})();
